import {
  ButtonType,
  DropdownButtonType,
  List,
  SingleSelectDropdown,
  TextLinkWidget
} from '@tableau/widgets';
import React from 'react';

import { ButtonWithSpinner } from '~commonInfra/components/ButtonWithSpinner';
import { HelpService } from '~commonInfra/services/HelpService';
import { Set } from '~commonInfra/utils/Set';

import { Formatters, Messages } from '../../codegen/Localize';
import { ISiteUserInfo } from '../users/models/ISiteUserInfo';
import { getIntegrationSiteRoleItems } from './IntegrationSiteRoleListItems';
import {
  SetIntegrationUserSiteRoleDialogContainerStyle,
  SiteRoleDropdownStyle
} from './styles/IntegrationUserDialogStyles';

const INTEGRATION_USERS_HELP_TOKEN = 'integration-users';

export interface SetIntegrationUserSiteRoleDialogProps {
  readonly close: () => void;
  readonly dismiss: () => void;
  readonly siteUsersToSet: Set<ISiteUserInfo>;
}

export interface SetIntegrationUserSiteRoleDialogState {
  readonly selectedRole: string | undefined;
  readonly busy: boolean;
}

export class SetIntegrationUserSiteRoleDialog
  extends React.Component<SetIntegrationUserSiteRoleDialogProps, SetIntegrationUserSiteRoleDialogState> {

  public constructor(props: SetIntegrationUserSiteRoleDialogProps) {
    super(props);
    const firstUser = props.siteUsersToSet.size() === 1 ? props.siteUsersToSet.first() as ISiteUserInfo : null;
    this.state = {
      selectedRole: firstUser ? firstUser.siteRole : undefined,
      busy: false
    };
  }

  private readonly handleSiteRoleChange = (value: string) => {
    this.setState({ selectedRole: value });
  };

  private readonly handleSubmit = () => {
    this.props.close();
  };

  public render() {
    const userCount = this.props.siteUsersToSet.size();
    const firstUser = this.props.siteUsersToSet.first() as ISiteUserInfo;
    const isSubmitDisabled = this.state.selectedRole == null || this.state.busy;
    const siteRoleButtonLabel = this.state.selectedRole == null
      ? Messages.addIntegrationUsersSiteRolePlaceholder()
      : undefined;
    return (
      <div className='tb-set-integration-user-role-modal' style={SetIntegrationUserSiteRoleDialogContainerStyle}>
        <div className='tb-dialog-title'>
          {Messages.confirmSetUsersSiteRoleTitle()}
        </div>
        <div className='tb-dialog-body-input-description'>
          {Messages.integrationUserSiteRoleDesc({
            USER_NAME: firstUser.displayName,
            USER_COUNT: userCount,
            USER_COUNT_LOC: Formatters.formatCount(userCount)
          })}{' '}
          <TextLinkWidget
            href={HelpService.getServerHelpUrlByCategory(INTEGRATION_USERS_HELP_TOKEN)}
            target='_blank'
            testId='integration-user-site-role-learn-more'
          >
            {Messages.learnMore()}
          </TextLinkWidget>
        </div>
        <div className='tb-margin-top-wide' style={SiteRoleDropdownStyle}>
          <SingleSelectDropdown
            list={<List items={getIntegrationSiteRoleItems()} />}
            value={this.state.selectedRole}
            onChange={this.handleSiteRoleChange}
            type={DropdownButtonType.Outline}
            label=''
            aria-label={Messages.siteRole_title()}
            testId='integration-user-site-role-dropdown'
            style={SiteRoleDropdownStyle}
          >
            {siteRoleButtonLabel}
          </SingleSelectDropdown>
        </div>
        <div className='tb-dialog-actions'>
          <ButtonWithSpinner
            buttonType={ButtonType.Outline}
            onClick={this.props.dismiss}
            testId={'confirm-action-dialog-cancel'}
            children={Messages.cancel()}
            disabled={this.state.busy}
          />
          <span className='tb-margin-left-wide'>
            <ButtonWithSpinner
              buttonType={ButtonType.Primary}
              showSpinner={this.state.busy}
              onClick={this.handleSubmit}
              testId={'confirm-action-dialog-submit'}
              disabled={isSubmitDisabled}
              children={Messages.confirmSetUsersSiteRoleButton({
                ITEM_COUNT: userCount,
                ITEM_COUNT_LOC: Formatters.formatCount(userCount)
              })}
            />
          </span>
        </div>
      </div>
    );
  }
}
